import { useState, useEffect, useCallback } from 'react';
import { onboardingApi, OnboardingStatus } from '../services/onboardingApi';

export const useOnboardingStatus = () => {
    const [status, setStatus] = useState<OnboardingStatus | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    const fetchStatus = useCallback(async () => {
        try {
            setLoading(true);
            const data = await onboardingApi.getStatus();
            setStatus(data);
            setError(null);
        } catch (err) {
            setError(err instanceof Error ? err : new Error('Failed to fetch onboarding status'));
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchStatus();
    }, [fetchStatus]);

    return { status, loading, error, refetch: fetchStatus };
};
